import { type InternalProductInfoType } from './types';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function extractProductOverrides(event: any): Partial<InternalProductInfoType> {
	const { env, product, subproduct, version, origin, platform } = event;
	return {
		env,
		product,
		subproduct,
		version,
		origin,
		platform,
	};
}
